import React, { Component } from 'react'
import { uniq } from 'lodash'
import ChooseDeliveryModal from './ChooseDeliveryModal'
import { getOfferByCourseId, searchValidUnits } from '../../../services/vu'
import { getCourseId } from '../../../helpers/course'
import {
  getActiveEnrollableCalendars,
  getCohortCodes
} from '../../../helpers/enrolment'
import ProcessType from '../../../enums/ProcessType'

class EditUnitModal extends Component {
  constructor(props) {
    super(props)

    this.state = {
      modalUnits: {},
      loadingUnitForModal: true,
      unitCode: props.unitCode
    }
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.isOpen &&
      prevProps.unitCode !== this.props.unitCode &&
      prevProps.unitAvailabilityStudyPeriodCode !==
        this.props.unitAvailabilityStudyPeriodCode &&
      prevProps.unitAvailabilityYear !== this.props.unitAvailabilityYear
    ) {
      this.initialise(this.props.unitCode)
    }
  }

  initialise = unitCode => {
    this.setState({
      loadingUnitForModal: true
    })

    this.setState({
      modalUnits: this.props.enrolledUnits.reduce(
        (accumulator, currentUnit) => {
          accumulator[currentUnit.unitCode] =
            accumulator[currentUnit.unitCode] || []
          accumulator[currentUnit.unitCode].push(currentUnit)
          return accumulator
        },
        Object.create(null)
      ),
      unitCode: unitCode,
      loadingUnitForModal: false
    })
  }

  render() {
    return (
      <ChooseDeliveryModal
        title="Choose Delivery"
        buttonText="Choose delivery"
        buttonLoadText="Choose delivery..."
        loading={this.state.loadingUnitForModal}
        units={this.props.enrolledUnits}
        enrolledUnits={this.props.enrolledUnits}
        unitCode={this.state.unitCode}
        handleCloseModal={this.props.handleCloseModal}
        handleSubmitUnit={this.props.handleSubmitUnit}
        handleError={this.props.handleError}
        isOpen={this.props.isOpen}
        submitting={this.props.submitting}
      />
    )
  }
}

export default EditUnitModal
